<template>
  <div class="landingpage" >
<!--    <van-nav-bar :title="this.landingPage.title" class="title">-->
<!--    </van-nav-bar>-->
<!--    <van-image-->
<!--      width="10rem"-->
<!--      height="10rem"-->
<!--      fit="contain"-->
<!--      src="../assets/KV.png"-->
<!--    />-->
    <img src="../assets/KV1.png" style="width:10rem;"/>
    <div>
      <img src="../assets/title.png"  style="width:4.1rem;margin-top:2rem;"/>
      <van-form @submit="onSubmit" class="vForm">
        <div class="inputName">
          <input type="text" v-model.trim="FormInfo.name" autofocus="autofocus" placeholder="姓名">
        </div>
        <div class="inputName">
          <input type="tel" v-model.trim="FormInfo.phone" autofocus="autofocus" placeholder="手机号">
        </div>
<!--        <div style="display: flex;align-items: center;">-->
<!--          <div class="form-control">-->
<!--            <input type="tel" v-model.trim="dataForm.verifyCode" autofocus="autofocus" placeholder="请进行短信验证">-->
<!--            <span class="verify-button" :disabled="verifyContent.disabled" @click="obtainVerifyCode">-->
<!--              {{ verifyContent.text }}-->
<!--            </span>-->
<!--          </div>-->
<!--        </div>-->
        <div style="margin-top:0.507rem;display: flex;align-items: center;justify-content: center;">
          <van-checkbox v-model="sureAgree" checked-color="#ffb400" shape="square"></van-checkbox><span class="agreeText">已阅读并同意 </span><a class="agreeTextRule" @click="openDetailOpen">《个人信息与隐私保护条款》</a>
<!--            <input type="checkbox" shape="square" name="已阅读并同意" value="sureAgree" @change="changeSure"/><span class="agreeText">已阅读并同意 </span><a class="agreeTextRule" @click="openDetailOpen">《个人信息与隐私保护条款》</a></van-radio>-->
        </div>
        <div class="submitBox">
          <van-button :disabled="!this.sureAgree" block type="info" native-type="submit" @click="commit()">预约品鉴</van-button>
        </div>
        <div style="margin-top:0.7rem;">
          <img src="../assets/logo_text.png" style="width:10rem;"/>
        </div>
      </van-form>
      <div class="first_car">
        <van-swipe autoplay="false" lazy-render style="" class="first_car_swipe">
          <van-swipe-item v-for="image in images" :key="image">
            <img :src="image" />
          </van-swipe-item>
          <template #indicator="images">
            <div class="custom-indicator">
              <a class="leftArr"> <<< </a>
                左右滑动了解更多
              <a class="rightArr"> >>></a>
            </div>
          </template>
        </van-swipe>
        <div style="display: flex;align-items: center;justify-content: center;">
          <video
            id="video"
            src="../assets/car_video.mp4"
            controls="true"
            preload="auto"
            webkit-playsinline="true"
            playsinline="true"
            x-webkit-airplay="allow"
            x5-video-player-type="h5"
            style="object-fit: fill"
            controlslist="nodownload noremoteplayback"
            disablePictureInPicture="true"
            poster="../assets/video_cover.jpeg"
            loop
            autoplay
          ></video>
        </div>
        <van-swipe autoplay="false" lazy-render class="second_car_swipe">
          <van-swipe-item v-for="image in images1" :key="image">
            <img :src="image" />
          </van-swipe-item>
          <template #indicator="images1">
            <div class="custom-indicator">
              <a class="leftArr"> <<< </a>
              左右滑动了解更多
              <a class="rightArr"> >>></a>
            </div>
          </template>
        </van-swipe>
        <div class="bottom_logo_box">
          <img src="../assets/logo_bottom.png"/>
        </div>
      </div>
      <div style="width:10rem;display: flex;align-items: center;position: relative;">
        <van-dialog v-model="show" :lockScroll="true" width="300px" :confirm-button-text="'我知道了'" title="个人信息保护政策声明">
          <div>
            <div>
              <div>玛莎拉蒂（中国）汽车贸易有限公司（以下简称“玛莎拉蒂中国”或“我们”）非常注重对您个人信息的保护，并认为必须正确地告知您我们进行个人信息处理（包括信息的收集、存储、使用、加工、传输、提供、公开、删除等）的方法。我们希望通过本个人信息保护政策声明向您说明，您向我们提供的个人信息会根据中国个人信息保护的法律规定予以处理。</div>
              <div>请仔细阅读本政策声明。在需要时，您可按照本政策声明的指引，做出您认为适当的选择。</div>
              <h1>1、收集与处理个人信息的目的</h1>
              <div>您向玛莎拉蒂中国及其销售和服务网络提供的个人信息将用于以下目的：（a）为管理客户所要求之商品和服务的购买和销售的目的，向客户提供客户所要求之产品与服务；（b）为您提供商品和服务的相关配套服务；（c）通过电子邮件、邮寄、电话、传真、短信／彩信等方式发送与产品或服务相关的信息和促销推广资料，组织和举办促销推广活动和演示活动、客户忠诚度相关的活动、节目和／或展会，以及开发客户满意度市场研究；（d）分析您的偏好、习惯和消费者选择，以便以匿名形式向您发送个性化的宣传信息并开展统计研究；（e）根据相关法律要求配合行政部门的监管。</div>
              <h1>2、我们收集的个人信息</h1>
              <div>玛莎拉蒂中国与受玛莎拉蒂中国委托的第三方服务提供商在获得您同意后将收集有关您的个人信息，范围包括您在访问玛莎拉蒂授权经销商时主动提供的个人信息、您通过我们的客服或参加我们举办的活动时所提交的信息，以及我们在您访问和使用我们的在线服务时收集的有关您的信息。包括但不限于：</div>
              <div>-个人身份信息：姓名、身份证号码、职业等</div>
              <div>-联络信息：手机号码、邮箱地址、通讯地址及社交账号等</div>
              <div>-车辆信息：驾驶证号码、车架号等</div>
              <div>-位置信息：合理精度的位置信息及部分行动轨迹等</div>
              <div>我们将不时更新上述个人信息内容并第一时间向您通知和/或公布。</div>
              <h1>3、个人信息处理与个人信息安全</h1>
              <div>您的个人信息将仅为上述之目的使用合适的纸质、电子和/或其他方式进行处理，我们提供技术措施和其他必要措施以确保您个人信息的安全性和保密性。在发生或者可能发生个人信息泄露、篡改、丢失的，应当及时采取补救措施的情况下，我们将按照规定向您告知并按照法律规定向主管部门进行报告。我们也会要求我们的第三方服务提供商使用商业合理安全措施以保护您的个人信息不被非授权人员访问或者使用。但是，任何数据传输都不能保证百分之百安全。自您向我们提供个人信息起，我们将妥善处理您的个人信息直至您不再接受我们商品和服务或要求我们删除相关个人信息。</div>
              <h1>4、必要个人信息</h1>
              <div>为了与玛莎拉蒂中国建立业务关系，以满足您的需求并遵守相关法律要求，您必须提供为第1条（a）项和（b）项所述之目的而需要的个人信息。如果您没有提供您的个人信息，或者提供的个人信息不完整或不准确，我们可能无法与您建立完善的业务关系或提供完善的产品或服务。对于第1条中（a）项和（b）项所述之外的其他目的，您可以选择是否提供您的个人信息。如果您不提供个人信息，或者提供的数据不正确，这不会影响您购买所需商品和／或服务的能力。</div>
              <h1>5、个人信息分享与披露</h1>
              <div>您的数据可能由我们内部的相关工作人员处理或可能由我们指定负责个人信息处理的所有管理人员和负责人处理。</div>
              <div>除此以外，经合法性、必要性评估后，我们可能与关联公司、经销商、代理商及其他第三方服务提供商（以下简称“第三方”）在必要的范围内授权处理你的个人信息，该等分享主要是为了更好的为您提供服务。第三方如要改变本政策声明第1条所述的个人信息的处理目的，将再次征求您的授权同意。例如，我们可能授权我们的经销商与您取得联系，为您提供您所要求的试驾服务，或者，我们可能授权我们的关联公司向您发送您所订阅的信息等。</div>
              <div>我们或我们的关联公司还可能为以下需要而保存、应用或披露您的个人信息：</div>
              <div>
                <ul>
                  <li>遵守适用的法律法规；</li>
                  <li>遵守诉讼、法院命令或其他法律程序的规定；</li>
                  <li>遵守相关政府主管部门的强制性要求；</li>
                  <li>为遵守适用的法律法规、维护社会公共利益，或为保护我们的客户、我们或我们的集团公司、其他用户或雇员的人身和财产安全或合法权益所必需的合理用途。</li>
                </ul>
              </div>
              <div>另外，我们可能会对外公开，并与合作伙伴（例如客户、关联网站、广告服务提供商）分享经过加工无法识别特定个人且不能复原的信息。</div>
              <h1>6、数据传播</h1>
              <div>我们不会传播散布您的个人信息。</div>
              <h1>7、联系我们</h1>
              <div>本个人信息保护政策最近的更新日期为：2021年10月。如果您对上述政策内容或对您的个人信息保护有任何咨询或疑问，或您希望查阅我们所有持有的您的个人信息的内容，或要求对您所提供的个人信息做出更正或更新（但是，特定的法规，尤其与安全问题或者财务有关的法规，可能会禁止更改您的信息），或者发现我们违反法律、行政法规的规定或者双方的约定收集、使用其个人信息，或者发现我们收集、存储的其个人信息有错误的或有任何疑问、意见或建议的，请通过拨打玛莎拉蒂中国客户电话[4006885111]方式与我们联系[Note:联系方式]。为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。我们将会收到您的询问/要求后尽快给予答复。该答复是免费的，除非提供该答复的成本或要求提供该答复的频率是不合理的。</div>
              <div>个人信息保护政策声明 - 同意书</div>
              <div>本人已阅读并理解以上个人信息保护政策声明，并且同意玛莎拉蒂中国根据本个人信息保护政策声明中所述的内容对本人的个人信息进行处理。</div>
            </div>
<!--            <iframe style="height: 50vh;padding:10px;" src="http://mpage.frensworkz.com/wap/privacy.html" id="if1"></iframe>-->
          </div>
        </van-dialog>
      </div>
    </div>
<!--    <div class="swiper">-->
<!--      <van-swipe :autoplay="3000" :loop="true" indicator-color="#fff">-->
<!--        <van-swipe-item v-for="(image, index) in SwiperImg" :key="index">-->
<!--          <img :src="image">-->
<!--        </van-swipe-item>-->
<!--      </van-swipe>-->
<!--    </div>-->
<!--    <div>-->

<!--    </div>-->

<!--    1-->
<!--    1-->
<!--    1-->
<!--    <van-form @submit="onSubmit" class="vForm">-->
<!--      <van-field v-model="FormInfo.name" name="姓名" label="姓名" placeholder="请输入姓名" :rules="[{ required: true }]"/>-->
<!--      <van-field v-model="FormInfo.phone" name="手机号" label="手机号" placeholder="请输入手机号" :rules="[{ required: true, message: '请填写您的手机号码！' },{ pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误！'}]"/>-->
<!--      <van-field-->
<!--        :rules="[{ required: true }]"-->
<!--        readonly-->
<!--        clickable-->
<!--        label="性别"-->
<!--        :value="FormInfo.gender"-->
<!--        placeholder="选择性别"-->
<!--        @click="showGenderPicker = true"-->
<!--      />-->
<!--      <van-field-->
<!--        :rules="[{ required: true }]"-->
<!--        readonly-->
<!--        clickable-->
<!--        label="地域"-->
<!--        :value="FormInfo.area"-->
<!--        placeholder="选择地域"-->
<!--        @click="showAreaPicker = true"-->
<!--      />-->
<!--      <van-field v-if="this.landingPage.brand_flag === 1"-->
<!--        :rules="[{ required: true }]"-->
<!--        readonly-->
<!--        clickable-->
<!--        label="车型"-->
<!--        :value="FormInfo.brands"-->
<!--        placeholder="选择车型"-->
<!--        @click="showBrandPicker = true"-->
<!--      />-->
<!--      <van-field v-if="this.landingPage.dealer_flag === 1"-->
<!--        :rules="[{ required: true }]"-->
<!--        readonly-->
<!--        clickable-->
<!--        label="经销商"-->
<!--        :value="FormInfo.dealer"-->
<!--        placeholder="选择经销商"-->
<!--        @click="showDealerPicker = true"-->
<!--      />-->
<!--      <div style="margin:16px;">-->
<!--        <van-button round block type="info" native-type="submit" @click="commit()">提交</van-button>-->
<!--      </div>-->
<!--      2-->
<!--      2-->
<!--      2-->
<!--      2-->
      <!--    <van-    </van-form>
popup class="GenderPop" v-model="showGenderPicker" round position="bottom">-->
<!--        <van-picker-->
<!--        title="性别"-->
<!--        show-toolbar-->
<!--        :columns="Genders"-->
<!--        @cancel="showGenderPicker = false"-->
<!--        @confirm="changeGenderConfirm"-->
<!--        />-->
<!--    </van-popup>-->
<!--    <van-popup class="AreaPop" v-model="showAreaPicker" round position="bottom">-->
<!--        <van-cascader-->
<!--        v-model="FormInfo.areaValue"-->
<!--        title="请选择所在地区"-->
<!--        :options="citys"-->
<!--        @close="showAreaPicker = false"-->
<!--        @finish="changeAreaConfirm"-->
<!--      />-->
<!--    </van-popup>-->
<!--    <van-popup class="DealerPop" v-model="showDealerPicker" round  </div> position="bottom">-->
<!--        <van-picker-->
<!--        title="请选择经销商"-->
<!--        show-toolbar-->
<!--        :columns="dealers"-->
<!--        @cancel="showDealerPicker = false"-->
<!--        @confirm="changeDealerConfirm"-->
<!--        />-->
<!--    </van-popup>-->
<!--    <van-popup class="BrandPop" v-model="showBrandPicker" round position="bottom">-->
<!--        <van-cascader-->
<!--        v-model="FormInfo.brandValue"-->
<!--        title="请选择品牌车系"-->
<!--        :options="brands"-->
<!--        @close="showBrandPicker = false"-->
<!--        @finish="changeBrandConfirm"-->
<!--      />-->
<!--    </van-popup>-->
  </div>
</template>

<script>
// @ is an alias to /src
import { createLead, getLandingPage, getBrand, getDealer, getArea } from '../../api/api.js'
export default {
  data () {
    return {
      images: [
        require('../assets/car_img/1.jpg'),
        require('../assets/car_img/2.jpg'),
        require('../assets/car_img/3.jpg'),
        require('../assets/car_img/4.jpg'),
        require('../assets/car_img/5.jpg')
      ],
      images1: [
        require('../assets/car_img1/01：GT-1.jpg'),
        require('../assets/car_img1/02：Trofeo-1.jpg'),
        require('../assets/car_img1/03：Modena.jpg'),
        require('../assets/car_img1/04：GT-2.jpg'),
        require('../assets/car_img1/05：Trofeo-2.jpg')
      ],
      campaignId: '',
      source: '',
      FormInfo: {
        name: '',
        phone: '',
        gender: '',
        pro: '',
        city: '',
        area: '',
        brands: '',
        brand: '',
        dealer: '',
        series: ''
      },
      SwiperImg: [],
      landingPage: {},
      brands: [],
      dealers: [],
      Genders: ['男', '女', '未知'],
      citys: [],
      showGenderPicker: false,
      showAreaPicker: false,
      showBrandPicker: false,
      showDealerPicker: false,
      sureAgree: false,
      // 表单初始化数据
      dataForm: {
        channeId: '',
        type: 'USERNAME',
        phone: '',
        verifyCode: ''
      },
      // 获取验证码按钮
      verifyContent: {
        disabled: false,
        text: '获取验证码'
      },
      active: 1,
      total: 4,
      show: false
    }
  },
  created () {
    this.campaignId = this.$route.query.campaignId
    this.source = this.$route.query.source
    this.getLandingPage(this.campaignId)
    this.getArea(this.campaignId)
    // var r = document.getElementById('if1').contentWindow.frames[1].querySelector('body')
    // r.style.fontSize = '20%'
    // //获得iframe对象
    // var i1 = window.frames['iframe'];
    // //获得元素对象
    // var pText = i1.document.getElementById("id");
    // //修改大小
    // pText.style.fontSize = '10px';
  },
  methods: {
    changeSure(){
      console.log(this.sureAgree,'sureAgreesureAgreesureAgreesureAgree')
    },
    openDetailOpen(){
      this.show = true
    },
    // Dialog.alert({
    //   message: http://mpage.frensworkz.com/wap/privacy.html,
    // }).then(() => {
    //   // on close
    // })
    // 发送验证码
    obtainVerifyCode () {
      var self = this
      // if(self.validePhone()) {
      //   // 发送短信接口请求
      //   self.$http.post('/verify',self.dataForm).then(resp => {
      //     console.log('resp',resp)
      //   })
        self.countDown()
      // }
    },
    // 倒计时方法
    countDown () {
      var time = 60
      var timer = setInterval(() => {
        if(time == 0) {
          clearInterval(timer)
          this.verifyContent.disabled = false
          this.verifyContent.text = '获取验证码'
        } else {
          this.verifyContent.disabled = true
          this.verifyContent.text = `重新获取(${time}s)`
          time--
          console.log('time',time)
        }
      }, 1000);
    },
    onSubmit(){},
    getLandingPage (campaignId) {
      getLandingPage(campaignId).then(res => {
        this.landingPage = JSON.parse(res.data)
        this.SwiperImg = this.landingPage.material.split(',')
        if (this.landingPage.brand_flag === 1) {
          this.getBrand(this.campaignId)
        }
      })
    },
    async getBrand (campaignId) {
      const { data: res } = await getBrand({ campaign_id: campaignId })
      this.brands = JSON.parse(res).list
    },
    async getArea (campaignId) {
      const { data: res } = await getArea({ campaign_id: campaignId })
      this.citys = JSON.parse(res).list
    },
    async getDealer (campaignId, pro, city) {
      const { data: res } = await getDealer({ campaign_id: campaignId, province: pro, city: city })
      const l = JSON.parse(res).list
      this.dealers = []
      this.FormInfo.dealer = ''
      l.forEach(e => {
        this.dealers.push(e.dealer)
      })
    },
    changeGenderConfirm (val, index) {
      this.FormInfo.gender = val
      this.showGenderPicker = false
    },
    changeAreaConfirm ({ selectedOptions }) {
      this.showAreaPicker = false
      this.FormInfo.area = selectedOptions.map((option) => option.text).join('/')
      this.FormInfo.pro = selectedOptions[0].text
      this.FormInfo.city = selectedOptions[1].text
      if (this.landingPage.dealer_flag === 1) {
        this.getDealer(this.campaignId, this.FormInfo.pro, this.FormInfo.city)
      }
    },
    changeBrandConfirm ({ selectedOptions }) {
      this.showBrandPicker = false
      this.FormInfo.brands = selectedOptions.map((option) => option.text).join('/')
      this.FormInfo.brand = selectedOptions[0].text
      this.FormInfo.series = selectedOptions[1].text
    },
    changeDealerConfirm (val, index) {
      this.FormInfo.dealer = val
      this.showDealerPicker = false
    },
    async commit () {
      debugger

      if (!this.FormInfo.name || !this.FormInfo.phone ) {
      // || !this.FormInfo.gender || !this.FormInfo.area
        return this.$toast('请正确填写信息')
      }
      if (!this.sureAgree) {
        console.log(this.sureAgree, '请先阅读统一相关条款')
        return this.$toast('请先阅读同意相关条款！')
      }
      // let gender = 'Unknown'
      // if (this.FormInfo.gender === '男') {
      //   gender = 'Male'
      // } else if (this.FormInfo.gender === '女') {
      //   gender = 'Female'
      // }
      // if (!this.FormInfo.dealer) {
      //   this.FormInfo.dealer = '无'
      // }
      try {
        await createLead({ name: this.FormInfo.name, phone: this.FormInfo.phone, campaign_id: this.campaignId})
        // province: this.FormInfo.pro, city: this.FormInfo.city, source: this.source, campaign_id: this.campaignId, gender: gender, brand: this.FormInfo.brand, series: this.FormInfo.series, dealer: this.FormInfo.dealer
        this.FormInfo.name = undefined
        this.FormInfo.phone = undefined
        this.$toast.success('提交成功')
      } catch (err) {
        if (err.response.status === 400) {
          const json = JSON.parse(err.response.data)
          this.$toast(json.error)
        } else {
          console.log(err)
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.leftArr {
  animation-name: move; //名称
  animation-duration: 10s; //时间
  animation-iteration-count: infinite; //无限循环
  animation-timing-function: linear;
}
@keyframes move {
  from{
    transform: translateX(0);
  }to{
     transform: translateX(-960px);//-960px是屏幕总宽度
   }
}
/deep/.first_car .first_car_swipe{
  height: 12.56rem;
}
/deep/.first_car .second_car_swipe{
  height:6.67rem;
}
/deep/.first_car video{
  width:10rem;
}

.inputName{
  height: 1.2rem;
  margin-bottom: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.inputName input{
  color:#fff;
  width: 7.707rem;
  height: 1.2rem;
  background: #2b2b2b;
  padding: 0px;
  border: none;
  font-size: 0.427rem;
  padding: 0px 0.44rem;
  box-sizing: border-box;
}
.landingpage{
  background: url('../assets/bg.png') no-repeat 0% 0%;
  background-size: cover;
  width:10rem;
}
.van-cell{
  left: 50%;
  transform: translateX(-50%);
  width: 7.71rem;
  height: 1.2rem;
  line-height: 1.2rem;
  background: #2b2b2b;
  margin-bottom: 0.44rem;
  padding: 0px 0.44rem;
  font-size: 0.427rem;
}
.form-control{
  margin: 0 1.145rem;
  width: 7.71rem;
  height: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.form-control input{
  width: 4.826rem;
  height:100%;
  color: #bfbfbf;
  font-size: 0.427rem;
  background: #2b2b2b;
  border-color: transparent;
  padding: 0px 0.44rem;
  box-sizing: border-box;
}
/deep/.van-field__control{
  color: #bfbfbf;
}
.verify-button{
  color: #ffb400;
  font-size: 0.427rem;
  padding-right: 0.3rem;
}
.van-field__label{
  color: #bfbfbf;
  display: none;
}
/deep/.van-checkbox__icon{
  font-size:0.43rem;
}
.agreeText{
  color: #bfbfbf;
  font-size: 0.36rem;
  margin-left:2px;
}
.agreeTextRule{
  color: #ffb400;
  font-size: 0.36rem;
}
.van-cell::after{
  border-color: transparent;
}
.submitBox{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top:0.907rem;
}
.submitBox .van-button--block{
  font-size: 0.47rem;
  width:7.07rem;
  height:1.2rem;
  background: transparent;
  box-sizing: border-box;
  border: 2px solid #ffb400;
}

.title {
  height: 1.25rem;
  text-align: center;
}
.swiper {
     width: 100%;
     height: 9rem;
    .van-swipe{
      width: 100%;height: 100%;
    }
    img {
      width: 100%;
      height: 100%;
      pointer-events: none;
    }
    .custom-indicator {
      position: absolute;
      right: 5px;
      bottom: 5px;
      padding: 2px 5px;
      font-size: 12px;
      color: #fff;
      background: #fff;
    }
}
.vForm {
  margin-top: 0.67rem;
}
.first_car_swipe .van-swipe-item img{
  width:10rem;
  height:12.56rem;
}
.second_car_swipe .van-swipe-item img{
  width:10rem;
  height:6.67rem;
}
.first_car_swipe .custom-indicator{
  font-size: 0.213rem;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 4.6rem;
  padding: 2px 5px;
  font-size: 12px;
  color: #ffff;
  background: rgba(0, 0, 0, 0.1);
}
.second_car_swipe  .custom-indicator {
  font-size: 0.213rem;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0.5rem;
  padding: 2px 5px;
  font-size: 12px;
  color: #ffff;
  background: rgba(0, 0, 0, 0.1);
}
.bottom_logo_box{
  width: 10rem;
  height: 4.5rem;
  background: #000;
  position: relative;
}
.bottom_logo_box img{
  height: 4.5rem;
  left: 50%;
  position: absolute;
  transform: translateX(-50%) translateY(-50%);
  top: 50%;
}
/deep/.van-dialog{
  top:45%;
  left:50%;
  transform: translateX(-50%) translateY(-50%);
}
.landingpage{
  overflow-x: hidden;
}
/deep/.van-checkbox__icon .van-icon{
  width:1em;
  height:1em;
  line-height: 1;
}
/deep/.van-checkbox__icon{
  display: flex;
  align-items: center;
  justify-content: center;
}
/deep/.van-dialog__content{
  max-height: 7rem;
  overflow-y: auto;
  text-align: left;
  padding: 8px;
}
/deep/.van-dialog__content h1{
  font-size:0.5rem;
  //color: red;
}
/deep/.van-dialog__content ul li{
  list-style: inside;
}
#app{
  overflow-x: hidden;
}
/deep/.van-dialog__confirm,/deep/ .van-dialog__confirm:active{
  color: #ffb400;
}
</style>
